<div class="main-content">
    <div class="container-fluid">
      <div *ngIf="this.privilegio.level != 'VENDOR'" style="float: right; margin-right: 20px" class="row">
         <button (click)="openNuevoFolder()" mat-raised-button class="btn btn-success">
                <span class="btn-label">
                  <i class="material-icons">create_new_folder</i>
                </span>
                 New Folder
              </button>
      </div>
      <div class="clearfix"></div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                  <div class="card-header card/-header-primary card-header-icon">
                    <div class="card-icon">
                      <i class="material-icons">assignment</i>
                    </div>
                    <h4 class="card-title">Company Files</h4>
                  </div>
                    <div style="padding: 40px;" class="card-body">

                      <div id="posearch"> <!-- inicia PO Search -->
                        <!--  <a (click)="showposrch()" style="color: green;
    font-weight: 500;cursor: pointer;"> <i class="material-icons">
search
</i> PO Search</a>-->
                      <div *ngIf="this.showposearch == 1" id="container-po-search">
                        <form>
                            <input type="text" placeholder="Search PO" class="form-control" [(ngModel)]="this.advancedpotext" name="advancedpotext" >

                            <button class="btn btn-info" (click)="searchPO()">Search </button>
                          </form>
                        </div>

                     <div id="showMsgPOSearching" style="display: none;" class="alert alert-info" role="alert">
                      <i style="   color: white;" class="material-icons">
sync
</i> Please wait, searching in progress
                    </div>

                     <div *ngIf="this.showMsgPOSearchingNotResults == 1" id="showMsgPOSearchingNotResults" class="alert alert-danger" role="alert">
                      <i style="   color: white;" class="material-icons">
cancel
</i> No records found, please try again
                    </div>

                       <div  *ngIf="this.showsearchPOResults == 1" class="material-datatables">
                          <table id="datatablesPOSearch" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%">
                                <thead>
                                    <tr>
                                      
                                      <th>{{ dataTablePOSearch.headerRow[0] }}</th>
                                      
                                      
                                      <th class="disabled-sorting text-right">{{ dataTablePOSearch.headerRow[1] }}</th>
                                    </tr>
                                </thead>
                                <tfoot>
                                    <tr>
                                   
                                      <th>{{ dataTablePOSearch.footerRow[1] }}</th>
                                     
                                     
                                      <th class="text-right">{{ dataTablePOSearch.footerRow[1] }}</th>
                                    </tr>
                                </tfoot>
                                <tbody>
                                    <tr *ngFor="let row of dataTablePOSearch.dataRows" id="file{{row[0]}}">
                                    
                                        <td>{{row[1]}}</td>
                                       
                                        <td class="text-right">
                                           <a  (click)="goFolder(row[0])"><button mat-raised-button class="btn btn-info">Open Folder</button></a>
                                         
                                       
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                          
                        </div>

                        </div><!-- end PO Search -->
                        
                        <div class="toolbar">
                            <!--        Here you can write extra buttons/actions for the toolbar              -->
                        </div>
                        <div class="material-datatables">
                          <table id="datatables" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%">
                                <thead>
                                    <tr>
                                      <th class="disabled-sorting">{{ dataTable.headerRow[0] }}</th>
                                   
                                      <th>{{ dataTable.headerRow[2] }}</th>
                                   
                                      
                                      <th class="disabled-sorting text-right">{{ dataTable.headerRow[4] }}</th>
                                    </tr>
                                </thead>
                              
                                <tbody>
                                    <tr id="folder{{row[0]}}" style="background-color: beige;" *ngFor="let row of dataTable.dataRows">
                                     
                                        <td><i class="material-icons">
folder
</i></td>
<td class="text-left">{{row[1]}}</td>
                                       
                                       
                                       
                                        <td class="text-right">
                                          <a  [routerLink]="['/tables/listcompanyfiles', row[0]]" ><button mat-raised-button class="btn btn-info">Open</button></a>

                                         
                                          <a (click)="deleteFolderfirst(row[0])" *ngIf="this.privilegio.level == 'ADMINISTRATOR' || this.identity.sub == row[4]" 
                                         class="btn btn-link btn-danger btn-just-icon"><i class="material-icons">close</i></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                             <input type="hidden" name="borrarFolder" value="" id="borrarFolder" (click)="deleteFolder()">
                            <input type="hidden" name="borrarUser" value="" id="borrarUser" (click)="deleteUser()">
                        </div>
                    </div>
                    <!-- end content-->
                </div>
                <!--  end card  -->
            </div>
            <!-- end col-md-12 -->
        </div>
        <!-- end row -->
    </div>
</div>
